<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :query-api="historyApi" :ignoreMaxTableItemLimit="true"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPrPriceResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions  edit-disable="true" :query-api="historyApi"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'" tableExportUrl="findByFilterWithHistory"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"  detailInlineButtonType="showAttachmentEntity"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author Shi Wen Long
    // Date 2021-06-25 10:35:42

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import {mapActions} from 'vuex';
    import MiniButton from "@/components/common/buttons/MiniButton.vue";
    import PageMaterialDownloadBomDrawingMixin
        from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";

    export default {
        name: "sithMesStoolPrPriceListView",
        components: {MiniButton},
        mixins: [emCommonListMixin, emCommonApiMixin, PageMaterialDownloadBomDrawingMixin],
        data(){
            return {
                historyApi:'showHistory'
            }
        },
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        computed:{
            modelName(){
                return 'sithMesStoolPrPrice';
            },
            $_rowMaterialKey() {
                return 'matCode';
            }
        },
        methods:{
            getDetailInlineButtonType(row) {
                if(row.attachments) {
                    return 'showAttachmentEntity';
                }

                return 'showEntity';

            },
            ...mapActions("base", ["showSuccess", "showDanger", "showWarning"]),
        },
        mounted(){
            this.$refs["emListFilter"].doQuery();
        }
    };
</script>
